import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  TextField,
  Select,
  MenuItem,
  Box,
  IconButton,
  Autocomplete,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";

import { toast } from "sonner";
import Api from "../../Api/Api";

export default function AddColumnDialog({
  open,
  onClose,
  columnName,
  setColumnName,
  columnType,
  setColumnType,
  fetchData,
  setListSuggestions,
}) {
  // ✅ dropdown options state
  const [options, setOptions] = useState([
    {
      label: "",
      color: "#1976d2",
    },
  ]);

  const [listType, setListType] = useState("");
  const [listOptions, setListOptions] = useState([]);

  const addOption = () => {
    setOptions((prev) => [
      ...prev,
      {
        label: "",
        color: "#1976d2",
      },
    ]);
  };

  const removeOption = (index) => {
    setOptions((prev) => prev.filter((_, i) => i !== index));
  };

  const updateOption = (index, key, value) => {
    const updated = [...options];
    updated[index][key] = value;
    setOptions(updated);
  };
  const fetchListSuggestions = async () => {
    const res = await Api.get("/dashboard/column-suggestions");

    const grouped = res.data.reduce((acc, item) => {
      if (!acc[item.type]) acc[item.type] = [];
      acc[item.type].push(item.carrier_name);
      return acc;
    }, {});

    setListSuggestions(grouped);
  };
  const handleSave = async () => {
    try {
      await Api.post("/dashboard/add-column", {
        column_name: columnName,
        data_type: columnType === "list" ? "string" : columnType,

        ui_type: columnType,

        list_type: listType,

        // ✅ send dropdown options
        options:
          columnType === "select"
            ? options.map((o) => ({
                label: o.label,
                color: o.color,
              }))
            : [],
      });

      await Promise.all(
        listOptions.map((item) =>
          Api.post("/dashboard/save-column-suggestion", {
            carrier_name: item,
            type: listType,
          }),
        ),
      );

      toast.success("Column Added");

      onClose();

      setColumnName("");
      setColumnType("string");

      setOptions([
        {
          label: "",
          color: "#1976d2",
        },
      ]);

      await fetchData();
      if (setListSuggestions) {
        const res = await Api.get("/dashboard/column-suggestions");

        const grouped = res.data.reduce((acc, item) => {
          if (!acc[item.type]) acc[item.type] = [];
          acc[item.type].push(item.carrier_name);
          return acc;
        }, {});

        setListSuggestions(grouped);
      }
    } catch (err) {
      console.error(err);

      toast.error(err?.response?.data?.message || "Failed to add column");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Column</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          {/* COLUMN NAME */}
          <TextField
            label="Column Name"
            fullWidth
            value={columnName}
            onChange={(e) => setColumnName(e.target.value)}
          />

          {/* COLUMN TYPE */}
          <Select
            value={columnType}
            onChange={(e) => setColumnType(e.target.value)}
            fullWidth
          >
            <MenuItem value="string">Text</MenuItem>

            <MenuItem value="decimal">Number</MenuItem>

            <MenuItem value="date">Date</MenuItem>

            <MenuItem value="select">Select</MenuItem>

            <MenuItem value="list">Dropdown</MenuItem>
          </Select>

          {/* ✅ DROPDOWN OPTIONS */}
          {columnType === "select" && (
            <Box>
              <Stack spacing={2}>
                {options.map((option, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                    }}
                  >
                    {/* LABEL */}
                    <TextField
                      label="Option Label"
                      fullWidth
                      value={option.label}
                      onChange={(e) =>
                        updateOption(index, "label", e.target.value)
                      }
                    />

                    {/* COLOR PICKER */}
                    <input
                      type="color"
                      value={option.color}
                      onChange={(e) =>
                        updateOption(index, "color", e.target.value)
                      }
                      style={{
                        width: 60,
                        height: 45,
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                      }}
                    />

                    {/* DELETE */}
                    <IconButton
                      color="error"
                      onClick={() => removeOption(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                ))}

                {/* ADD OPTION BUTTON */}
                <Button variant="outlined" onClick={addOption}>
                  + Add Option
                </Button>
              </Stack>
            </Box>
          )}

          {columnType === "list" && (
            <Box>
              <Stack spacing={2}>
                {/* LIST TYPE */}
                <TextField
                  label="List Type"
                  fullWidth
                  value={listType}
                  onChange={(e) => setListType(e.target.value)}
                  placeholder="Example: credit_type"
                />

                {/* AUTOCOMPLETE */}
                <Autocomplete
                  multiple
                  freeSolo
                  options={[]}
                  value={listOptions}
                  onChange={(event, newValue) => {
                    setListOptions(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Suggestions"
                      placeholder="Add suggestions"
                    />
                  )}
                />
              </Stack>
            </Box>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>

        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
